/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarCardHeader\CarCardHeader.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 20th 2023
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Styles from "Content/Car/CarCardHeader/CarCardHeader.module.css";
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { useEffect, useState, MouseEvent } from 'react';
import Button from 'Theme/Component/Button';
import { IconSubSectionType } from './CarCardHeader.type';
import CartIcon from "Theme/Component/CartIcon";
import { useInteractiveHeader } from "Router/HeaderInteractionProvider";
import CarService from "Services/Cars/CarService";
import { useAuth } from "Router/AuthProvider";

function CarCardHeader (props: IconSubSectionType) {
    const { isConnected } = useAuth();
    const { fav, setFav } = useInteractiveHeader();
    const [isLiked, setIsLiked] = useState(false);
    const [iconToDisplay, setIconSubSection] = useState("");

    useEffect(() => {
        setIsLiked(fav.find(x => x === props.id) ? true : false);
    }, [fav]);

    useEffect(() => {
        if (iconToDisplay == "")
        switch (props.IconSubSection) {
            case "BREAK":
                setIconSubSection("/IconsCarSubSection/BREAK_V1.svg");
                break;
            case "CITYCAR":
                setIconSubSection("/IconsCarSubSection/CITADINE_V1.svg");
                break;
            case "SUV":
                setIconSubSection("/IconsCarSubSection/SUV_V1.svg");
                break;
            case "UTILITY":
                    setIconSubSection("/IconsCarSubSection/VU_V1.svg");
                    break;
            case "SEDAN":
                setIconSubSection("/IconsCarSubSection/BERLINE_V1.svg");
                break;
            default:
                setIconSubSection("/IconsCarSubSection/UNKNOWN_V1.svg");
                break;
        }
    }, [iconToDisplay]);

    const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        CarService.addCarFav(props.id).then((result) => {
            setFav(result.data.fav, props.id);
            setIsLiked(result.data.fav);
        }).catch((error) => {
            console.error(error);
        });
    };

    return (
        <div className={`${Styles.label_car}`}>
            <div className={`${Styles.left_part}`}>
                {iconToDisplay !== "" ? <img className={`${Styles.icon_sub_car}`} src={iconToDisplay} alt="Car Icon"/> : null }
                <p className="m-0">Mobybuy</p>
            </div>
            {
                isConnected ?
                    (<Button onClick={handleToggle} aria-label="Add car to favorite" >
                        {
                            isLiked ?
                            <CartIcon bgColor={props.themeColor}><FaHeart /></CartIcon>
                            :
                            <CartIcon bgColor={props.themeColor}><FaRegHeart /></CartIcon>
                        }
                    </Button>)
                    :null
            }
        </div>
    );
}

export default CarCardHeader;
